import { jsx as e, jsxs as t } from "react/jsx-runtime";
import * as o from "@radix-ui/react-label";
import { twMerge as i } from "tailwind-merge";
const a = ({ className: s = "", ...r }) => /* @__PURE__ */ e(o.Root, { className: i("text-sm font-medium", s), ...r }), m = () => /* @__PURE__ */ t("span", { className: "font-medium text-red-600", children: [
  /* @__PURE__ */ e("span", { "aria-hidden": !0, children: "*" }),
  /* @__PURE__ */ e("span", { className: "sr-only", children: "(required)" })
] }), l = a, d = m;
export {
  d as Asterisk,
  a as Label,
  m as LabelAsterisk,
  l as Root
};
